import { render, staticRenderFns } from "./AutoReplyMessagesEditor.vue?vue&type=template&id=76b56bca&scoped=true"
import script from "./AutoReplyMessagesEditor.vue?vue&type=script&lang=js"
export * from "./AutoReplyMessagesEditor.vue?vue&type=script&lang=js"
import style0 from "./AutoReplyMessagesEditor.vue?vue&type=style&index=0&id=76b56bca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76b56bca",
  null
  
)

export default component.exports